import { useNavigate } from "react-router";

import CreateTeamForm from "./CreateTeamForm";
import { useCreateTeamMutation } from "@/lib/queries/team-queries";
import { paths } from "@/App";

// Not in active use but can be used to create a team if needed

export default function Setup() {
  const navigate = useNavigate();

  const { mutate: createTeam, isPending } = useCreateTeamMutation({
    onSuccess: async (data) => {
      navigate(paths.home(data.externalId));
    },
  });

  return (
    <div className="relative h-full w-full">
      <div className="absolute inset-0">
        <video
          src="/StudioBackground2.mp4"
          poster="/StudioBackground2.jpg"
          autoPlay
          muted
          loop
          playsInline
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center p-4">
        <CreateTeamForm onSubmit={createTeam} isPending={isPending} />
      </div>
    </div>
  );
}
